
import visual from "../view/systemManage/visual-intercom/visual-intercom";

import realTimeIntercom from "../view/systemManage/visual-intercom/talkback/real-time-intercom";
import historyIntercom from "../view/systemManage/visual-intercom/talkback/history-intercom";
const visualIntercom = {
    path: '/visual-intercom',
    component: visual,
    redirect: '/visual-intercom/real-time-intercom',
    children: [
        {
            path: '/visual-intercom/real-time-intercom',
            name: 'realTimeIntercom',
            component: realTimeIntercom,
            meta: {
                title: '实时对讲'
            }
        },
        {
            path: '/visual-intercom/history-intercom',
            name: 'historyIntercom',
            component:historyIntercom ,
            meta: {
                title: '历史对讲'
            }
        },
    ]
}

export default visualIntercom